module.exports = __webpack_public_path__ + "static/media/professional_details_icon.83dc1afa.svg";